export const listAcademicProgramsQuery = `
  query ListAcademicPrograms {
    listAcademicPrograms {
      code
      programs {
        id
        name
        code
        description
        status
        version
      }
    }
  }
`;

export const createAcademicProgramQuery = `
  mutation CreateAcademicProgram($input: CreateAcademicProgramInput!) {
    createAcademicProgram(input: $input) {
      code
      program {
        id
        name
        code
      }
    }
  }
`;

export const updateAcademicProgramMutation = `
  mutation UpdateAcademicProgram($input: UpdateAcademicProgramInput!) {
    updateAcademicProgram(input: $input) {
      code
      program {
        id
        name
        code
        description
        status
        version
      }
    }
  }
`;

export const archiveAcademicProgramMutation = `
  mutation ArchiveAcademicProgram($input: ArchiveAcademicProgramInput!) {
    archiveAcademicProgram(input: $input) {
      code
      program {
        id
        name
        status
        version
      }
    }
  }
`;

export const listGradesQuery = `
  query ListGrades($input: ListGradesInput!) {
    listGrades(input: $input) {
      code
      grades {
        id
        programId
        name
        sortOrder
        status
        version
      }
    }
  }
`;

export const createGradeQuery = `
  mutation CreateGrade($input: CreateGradeInput!) {
    createGrade(input: $input) {
      code
      grade {
        id
        programId
        name
      }
    }
  }
`;

export const archiveGradeMutation = `
  mutation ArchiveGrade($input: ArchiveGradeInput!) {
    archiveGrade(input: $input) {
      code
      grade {
        id
        name
        status
        version
      }
    }
  }
`;

export const listAcademicStreamsQuery = `
  query ListAcademicStreams($input: ListAcademicStreamsInput!) {
    listAcademicStreams(input: $input) {
      code
      streams {
        id
        gradeId
        name
      }
    }
  }
`;

export const createAcademicStreamQuery = `
  mutation CreateAcademicStream($input: CreateAcademicStreamInput!) {
    createAcademicStream(input: $input) {
      code
      stream {
        id
        gradeId
        name
      }
    }
  }
`;

export const listBillingPeriodsQuery = `
  query ListBillingPeriods($input: ListBillingPeriodsInput) {
    listBillingPeriods(input: $input) {
      code
      billingPeriods {
        id
        type
        parentId
        label
        startDate
        endDate
        status
      }
    }
  }
`;

export const createBillingPeriodQuery = `
  mutation CreateBillingPeriod($input: CreateBillingPeriodInput!) {
    createBillingPeriod(input: $input) {
      code
      billingPeriod {
        id
        type
        label
      }
    }
  }
`;

export const listDepartmentsQuery = `
  query ListDepartments {
    listDepartments {
      code
      departments {
        id
        name
        description
        status
      }
    }
  }
`;

export const createDepartmentQuery = `
  mutation CreateDepartment($input: CreateDepartmentInput!) {
    createDepartment(input: $input) {
      code
      department {
        id
        name
      }
    }
  }
`;

export const listStudentCategoriesQuery = `
  query ListStudentCategories {
    listStudentCategories {
      code
      studentCategories {
        id
        name
        description
        status
      }
    }
  }
`;

export const createStudentCategoryQuery = `
  mutation CreateStudentCategory($input: CreateStudentCategoryInput!) {
    createStudentCategory(input: $input) {
      code
      studentCategory {
        id
        name
      }
    }
  }
`;
